var map = {
	"./agave.png": 548,
	"./coffee.png": 1608,
	"./dark.png": 3228,
	"./hazelnut.png": 2127,
	"./mint.png": 160,
	"./strawberry.png": 6871,
	"./white.png": 673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2183;